<template>

	<div id="app">

		<partial-header></partial-header>

		<!--<transition name="fade" mode="out-in">
			<router-view name="rv-container" :key="$route.fullPath"></router-view>
		</transition>-->

		<router-view name="rv-container" :key="$route.fullPath"></router-view>

		<partial-footer v-if="!isPopupLayout"></partial-footer>

	</div>

</template>

<script>
import PartialHeader from "@/components/layouts/partialHeader";
import PartialFooter from "@/components/layouts/partialFooter";


export default {
	name: "layoutPage",
	components: {PartialFooter, PartialHeader},
	computed: {
		isPopupLayout() {
			const p = this.$route.query.popup;
			return p === '1' || p === 'true';
		}
	},
	created() {

	},
	mounted() {

	},
	updated() {

	}
}
</script>

<style scoped>

</style>
